import { observer } from 'mobx-react-lite';
import * as React from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import NoteTabs from '@/components/ui/NoteTabs';
import { ROUTES } from '@/configs/routes';
import { useRedirectOnRemovedEntity } from '@/hooks/useRedirectOnRemovedEntity';
import { useSidebarNoteStore } from '@/stores/local/sidebar/SidebarNoteStore';

import ConfirmPopup from '../../common/ConfirmPopup';
import InsightsLists from '../InsightsLists';

import { InsightsScopeTabKey } from './types';

import s from './InsightsTabContent.module.scss';

const InsightsTabContent: React.FC = () => {
  const { id, insightId } = useParams();
  const navigate = useNavigate();
  const { insights } = useSidebarNoteStore();

  useRedirectOnRemovedEntity(insights, insightId, id ? ROUTES.organization.notebook.insights.create(id) : null);

  React.useEffect(() => {
    insights.fetchInsights();
  }, [id, insights, navigate]);

  const handleTabChange = React.useCallback(
    (key: string) => {
      const k = key as InsightsScopeTabKey;

      insights.scopeTabs.setActiveKey(k);
      insights.fetchInsights();
    },
    [insights],
  );

  return (
    <div className={s.root}>
      <NoteTabs items={insights.scopeTabs.items} activeKey={insights.scopeTabs.activeKey} onChange={handleTabChange} />
      <InsightsLists />
      <ConfirmPopup
        meta={insights.popupMeta}
        store={insights.removePopup}
        title="Удалить инсайт?"
        description="Вы действительно хотите удалить этот инсайт? Восстановить его будет невозможно."
      />
      <ConfirmPopup
        meta={insights.popupMeta}
        store={insights.archivePopup}
        title="Архивировать инсайт?"
        description="Вы действительно хотите архивировать этот инсайт?"
        confirm="Архивировать"
      />
      <ConfirmPopup
        meta={insights.popupMeta}
        store={insights.activatePopup}
        title="Перенести инсайт в «Активные»?"
        description="Он снова будет доступен для редактирования"
        confirm="Перенести"
        confirmButtonProps={{ color: 'blue' }}
      />
    </div>
  );
};

export default observer(InsightsTabContent);
